// MB-I18N-2A — wallet EN (extrait de LanguageContext, valeurs inchangées).
export default {
  "wallet.title": "Wallet",
  "wallet.available_balance": "Available Balance",
  "wallet.recharge_notice": "Recharge at any SUPERKAWA® location",
  "wallet.your_card": "Your Wallet Card",
  "wallet.show_code": "Show this code to the barista for payments & rewards",
  "wallet.transactions": "Transactions",
  "wallet.prepaid_packs": "Prepaid Packs",
  "wallet.no_transactions": "No transactions yet",
  "wallet.no_packs": "No prepaid packs",
  "wallet.buy_packs": "Purchase packs at any store",
  "wallet.coffees_left": "coffees left",
  "wallet.copied": "QR code copied!",
  "wallet.updating": "Updating…",
  "wallet.loyalty_points": "Loyalty Points",
  "wallet.next_reward": "Next reward",
  "wallet.points_remaining_short": "{n} pts to go",
  "wallet.all_unlocked_title": "All rewards unlocked",
  "wallet.all_unlocked_subtitle": "Redeem your points now",
  "wallet.action_in_store": "In store",
  "wallet.action_online": "Online",
  "wallet.action_rewards": "Rewards",
  "wallet.my_card": "My Card",
  "wallet.copy": "Copy",
  "wallet.copied_short": "Copied!",
  "wallet.show_qr": "Show this code at the counter to pay or recharge",
  "wallet.welcome_offer_title": "Welcome Offer",
  "wallet.welcome_offer_desc": "Recharge {amount} or more to get 1 free classic drink!",
  "wallet.rewards_to_pick": "Rewards to pick up",
  "wallet.awaiting_validation": "Awaiting validation in store",
  "wallet.awaiting_badge": "Pending",
  "wallet.available_now": "Available now",
  "wallet.exchangeable": "Redeemable",
  "wallet.few_more_points": "A few more points",
  "wallet.history": "History",
  "wallet.no_transactions_long": "No transactions",
  "wallet.recharge_title": "Recharge my wallet",
  "wallet.recharge_show_qr": "Show this code at the counter to recharge",
  "wallet.amount_to_recharge": "Amount to recharge",
  "wallet.recommended": "⭐ Recommended",
  "wallet.custom_amount_note": "Custom amount possible at the counter, from {amount}.",
  "wallet.rewards_dialog_title": "Loyalty rewards",
  "wallet.my_points": "My points",
  "wallet.exchange": "Redeem",
  "wallet.point_ratio_msg": "You are {level}: 1 point earned every {ratio} {currency} spent",
  "wallet.points_history_title": "Points history",
  "wallet.total_points": "Total points",
  "wallet.level": "Level",
  "wallet.no_points_history": "No points history",
  "wallet.level_short": "Level {level} • 1 pt = {ratio} {currency} spent",
  "wallet.insufficient_points": "Not enough points",
  "wallet.error": "Error",
};
